import { render, staticRenderFns } from "./HomeTypeVideoComm.vue?vue&type=template&id=32f639ac&scoped=true&"
import script from "./HomeTypeVideoComm.vue?vue&type=script&lang=js&"
export * from "./HomeTypeVideoComm.vue?vue&type=script&lang=js&"
import style0 from "./HomeTypeVideoComm.vue?vue&type=style&index=0&id=32f639ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f639ac",
  null
  
)

export default component.exports